import React, {useEffect, useRef, useState} from "react";
import Sidebar from "../../components/Sidebar";
import DashboardDoctorHeader from "../../components/MainHeader/DashboardDoctorHeader";
import ChatAttachIcon from "../../assets/images/appointment-attach-icon.svg";
import appointmentChatIcon from "../../assets/images/appointment-chat-icon.svg";
import NoImage from "../../assets/images/no-image-avatar.png";
import leftArrowImg from "../../assets/images/left-arrow.svg";
import rightArrowImg from "../../assets/images/right-arrow.svg";
import CrossIcon from "../../assets/images/CrossIcon.svg";
import downloadIcon from "../../assets/images/download.svg";
import whiteDownloadIcon from "../../assets/images/white-download.svg";
import whiteImageIcon from "../../assets/images/white-image-icon.svg";
import blackImageIcon from "../../assets/images/black-image-icon.svg";
import whitePdfIcon from "../../assets/images/white-pdf-icon.svg";
import blackPdfIcon from "../../assets/images/black-pdf-icon.svg";
import whiteDocxIcon from "../../assets/images/white-docx-icon.svg";
import blackDocxIcon from "../../assets/images/black-docx-icon.svg";
import {toast} from "react-toastify";
import {
  chatFetchPatientApi,
  fetchDoctorMessageDetailsApi,
  fetchDoctorMessageListApi,
  getAppointmentMessageApi,
  readAppointmentMessageApi,
  readDoctorMessageApi,
  sendAppointmentMessageApi,
} from "../../services/apiService";
import {useLocation, useNavigate, useParams} from "react-router";
import LoadingPage from "../../components/LoadingPage";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import {chatMessgaeDateFormat, getFileExtension} from "../../utils/commonData";
import {useUserContext} from "../../context/UserContext";
import {IMAGE_URL} from "../../app_url";

const DoctorPatientMessage = () => {
  const {userData} = useUserContext();
  const {patientId} = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const chatListRef = useRef(null);
  const chatFileRef = useRef(null);
  const [allAppDetails, setAllAppDetails] = useState();
  const [appointmentDetails, setAppointmentDetails] = useState();
  const [screenLoading, setScreenLoading] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [messageSenderObj, setMessageSenderObj] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [alertShown, setAlertShown] = useState(false);
  const [messageText, setMessageText] = useState();
  const [messageFile, setMessageFile] = useState();
  const [messageSending, setMessageSending] = useState(false);
  const [leftMessageList, setLeftMessageList] = useState();
  const [selectedMessageId, setSelectedMessageId] = useState();
  const [selectedMessageItem, setSelectedMessageItem] = useState();
  const [rightMessageList, setRightMessageList] = useState();
  const [rightSectionLoad, setRightSectionLoad] = useState(false);

  const handleChatFileChange = event => {
    const acceptedFileTypes = [
      "image/jpeg", // JPG
      "image/png", // PNG
      "application/pdf", // PDF
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
    ];
    const file = event.target.files[0];
    if (!file) {
      toast.warning("No file selected.", {autoClose: 1500});
      return;
    }

    // Validate the file type
    if (!acceptedFileTypes.includes(file.type)) {
      toast.warning("Invalid file type. Please select a JPG, PNG, PDF, or DOCX file.", {autoClose: 1500});
      return;
    }

    setMessageFile(file);
  };

  const getDoctorMessageList = async () => {
    try {
      setScreenLoading(true);
      let response = await fetchDoctorMessageListApi();
      if (response) {
        if (response.data.res === true) {
          if (response.data.data.length > 0) {
            setLeftMessageList(response.data.data);
          } else {
            setLeftMessageList([]);
          }
        } else {
          toast.error(response.data.msg ? response.data.msg : "Something went wrong in server. Please try again.", {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setScreenLoading(false);
    }
  };

  const chatFetchPatientList = async () => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("patient_id", patientId);
      let response = await chatFetchPatientApi(fd);
      if (response) {
        if (response.data.res === true) {
          if (response.data.patients.length > 0) {
            setLeftMessageList(response.data.patients);
          } else {
            setLeftMessageList([]);
          }
        } else {
          toast.error(response.data.msg ? response.data.msg : "Something went wrong in server. Please try again.", {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setScreenLoading(false);
    }
  };

  const getDoctorMessageDetails = async id => {
    try {
      setScreenLoading(true);
      setRightSectionLoad(true);
      const fd = new FormData();
      fd.append("from_id", id);
      let response = await fetchDoctorMessageDetailsApi(fd);
      if (response) {
        if (response.data.res === true) {
          if (response.data.data.length > 0) {
            setRightMessageList(response.data.data);
          } else {
            setRightMessageList([]);
          }
        } else {
          toast.error(response.data.msg ? response.data.msg : "Something went wrong in server. Please try again.", {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setScreenLoading(false);
      setRightSectionLoad(false);
    }
  };

  const getAppointmentMessage = async appId => {
    try {
      setScreenLoading(true);
      setRightSectionLoad(true);
      const fd = new FormData();
      fd.append("appointment_id", appId);
      fd.append("type", "patient");

      let response = await getAppointmentMessageApi(fd);
      if (response) {
        if (response.data.res === true) {
          if (response.data.data.length > 0) {
            setRightMessageList(response.data.data);
          } else {
            setRightMessageList([]);
          }
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setScreenLoading(false);
      setRightSectionLoad(false);
    }
  };

  const handleLeftChatBoxClick = (item, id, fromId) => {
    setSelectedMessageItem(item);
    setSelectedMessageId(id);
    // getDoctorMessageDetails(fromId);
    handleReadMesssage(item?.patient_id);
    getAppointmentMessage(item?.id);
  };

  const handleReadMesssage = async messageId => {
    const tempSelectedItem = leftMessageList.find(item => parseInt(item?.doctor_id) === parseInt(messageId));

    try {
      const fd = new FormData();
      fd.append("from_id", messageId);
      fd.append("read_type", "doctor");
      let response = await readDoctorMessageApi(fd);
      if (response) {
        if (response.data.res === true) {
          const tempLeftMessageList = leftMessageList.map(item => (parseInt(item?.patient_id) === messageId ? {...item, unread_messages: 0} : item));
          setLeftMessageList(tempLeftMessageList);
        } else {
          toast.error(response.data.msg || "Something went wrong in server. Please try again.", {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
    }
  };

  const handleSendMesssage = async () => {
    if (!messageText && !messageFile) {
      toast.warning("Please enter a message or select a file to send.", {autoClose: 1500});
      return;
    } else {
      const tempAppItem = leftMessageList.find(item => item?.id === selectedMessageId);
      try {
        setMessageSending(true);
        const fd = new FormData();
        fd.append("appointment_id", tempAppItem?.id);
        fd.append("to_id", tempAppItem?.patient_id);
        fd.append("message", messageText ? messageText : "");
        fd.append("types", "patient");
        fd.append("message_file", messageFile ? messageFile : "");

        let response = await sendAppointmentMessageApi(fd);
        if (response) {
          if (response.data.res === true) {
            setMessageFile(null);
            setMessageSenderObj(null);
            setMessageText("");
            let tempArray = [...rightMessageList];
            tempArray.push(response.data.data);
            setRightMessageList(tempArray);
          } else {
            toast.error(response.data.msg || "Something went wrong in server. Please try again.", {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      } finally {
        setMessageSending(false);
      }
    }
  };

  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);

      // Check if the response is okay (status code 200)
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob(); // Convert response to a Blob
      const url = window.URL.createObjectURL(blob); // Create a temporary URL for the Blob

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName; // Set the filename for download
      document.body.appendChild(link);
      link.click(); // Programmatically click the link to trigger the download
      document.body.removeChild(link); // Clean up

      // Release the Blob URL after download
      window.URL.revokeObjectURL(url);

      toast.success("Downloaded successfully", {autoClose: 1500});
    } catch (error) {
      console.error("Error downloading the file:", error);
      toast.error("Failed to download the file.", {autoClose: 1500});
    }
  };

  const getQueryParams = () => {
    return new URLSearchParams(location.search);
  };

  useEffect(() => {
    // getDoctorMessageList();
    chatFetchPatientList();
    const query = getQueryParams();
    const toValue = query.get("to");
  }, []);

  useEffect(() => {
    // Scroll to the bottom of the chat list
    if (chatListRef.current) {
      chatListRef.current.scrollTop = chatListRef.current.scrollHeight;
    }
  }, [rightMessageList, selectedMessageItem]);

  useEffect(() => {
    const handleScroll = () => {
      const {scrollTop} = chatListRef.current;

      // Check if the user is scrolling up
      if (scrollTop < lastScrollTop) {
        // Check if the scroll position is near the top (within 100 pixels)
        if (scrollTop <= 100 && !alertShown) {
          // alert("You have reached the top of the chat list!");
          setAlertShown(true); // Set flag to true to prevent further alerts
        }
      } else {
        // Reset alert flag when scrolling down
        setAlertShown(false);
      }

      // Update the last scroll position
      setLastScrollTop(scrollTop);
    };

    const chatList = chatListRef.current;
    if (chatList) {
      chatList.addEventListener("scroll", handleScroll);
    }

    // Clean up the event listener on component unmount
    return () => {
      if (chatList) {
        chatList.removeEventListener("scroll", handleScroll);
      }
    };
  }, [lastScrollTop, messageList]);

  return (
    <div className="doctormain">
      <Sidebar />
      <div className="rightSec">
        <DashboardDoctorHeader />

        {screenLoading && <LoadingPage />}
        <div className="RoxBox DoctorMessagePage">
          <div className="LftDoctorConsultationObservations">
            <h3>Messages</h3>
          </div>
          <div className="RghtDoctorConsultationObservations">
            <div className="RghtDoctorConsultationObservationsTop">
              {allAppDetails?.previousId || allAppDetails?.nextId ? (
                <div className="NextAppHolder">
                  {allAppDetails?.previousId ? (
                    <Tooltip title={`Previous appointment`} placement="top">
                      <img src={leftArrowImg} className="ArrowIcon" onClick={() => navigate(`/doctor/appointment-details/${allAppDetails?.previousId}`)} />
                    </Tooltip>
                  ) : null}

                  <h4>
                    Date - {moment(appointmentDetails?.appointment_date).format("ddd D, YYYY")}, Time - {appointmentDetails?.time}
                  </h4>
                  {allAppDetails?.nextId ? (
                    <Tooltip title={`Next appointment`} placement="top">
                      <img src={rightArrowImg} className="ArrowIcon" onClick={() => navigate(`/doctor/appointment-details/${allAppDetails?.nextId}`)} />
                    </Tooltip>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {/* {!screenLoading ? ( */}
        <div className="RoxBox DoctorMessagePage">
          <div className="LftDoctorConsultationObservations MainSection">
            <ul className="AppointmentList DoctorMessageSection">
              {leftMessageList?.map((item, index) => (
                <li
                  key={index}
                  className={`${item?.id === selectedMessageId ? "Selected" : ""}`}
                  onClick={() => handleLeftChatBoxClick(item, item?.id, item?.from_id)}>
                  {/* <li className="Selected"> */}
                  <div className="Card">
                    <div className="TopCardBox">
                      <div className="ImgBox">
                        <img src={item?.profile_pic ? IMAGE_URL + item?.profile_pic : NoImage} alt="Doctor image" />
                      </div>
                      <div className="ImgTextBox">
                        <h4>{item?.name}</h4>
                        {/* <h5>Age: 34+</h5> */}
                        <h5>Patient</h5>
                      </div>
                    </div>
                    <div className="CardBottomTextBox">
                      <h3>Appointment details</h3>
                      <ul className="AppoBottomList">
                        <li>
                          <span className="DateSpan">{item?.appointment_date ? moment(item?.appointment_date).format("MMMM D, YYYY") : null}</span>
                          {/* <span className="DateSpan">October 17, 2024</span> */}
                          <span className="TimeSpan">{item?.time}</span>
                          <span className="chatIconSpan">
                            <img src={appointmentChatIcon} />
                            {item?.unread_messages > 0 ? <span className="unReadMsgCount">{item?.unread_messages}</span> : null}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="RghtDoctorConsultationObservations MainSection">
            <div className="WideChatBox">
              <div className="Card PatientsChatCard">
                {!screenLoading ? (
                  !selectedMessageItem ? (
                    <>
                      <div className="EmptyChatBox">
                        <ul>
                          <li>{leftMessageList?.length > 0 ? "Please select a person to start conversation." : "No Conversation found."}</li>
                        </ul>
                      </div>
                    </>
                  ) : (
                    <>
                      <button className="PatientsChatButton active">
                        {!rightSectionLoad ? (
                          <>
                            <span className="PatientImgBox">
                              <img src={selectedMessageItem?.profile_pic ? IMAGE_URL + selectedMessageItem?.profile_pic : NoImage} alt="Doctor image" />
                            </span>
                            <div className="PatientImgTextBox">
                              <div className="LeftImgTextBox">
                                <h4>{selectedMessageItem?.name}</h4>
                                <h5>{selectedMessageItem?.cell_phone}</h5>
                              </div>
                              <span className="ChatLink">
                                <img src="/src/assets/images/appointment-chat-icon.svg" alt="Doctor image" />
                              </span>
                            </div>
                          </>
                        ) : null}
                      </button>
                      <div className="BottomChatBox">
                        <ul className="ChatList" ref={chatListRef}>
                          {!rightSectionLoad ? (
                            rightMessageList?.length > 0 ? (
                              rightMessageList?.map((item, index) => (
                                <li key={index} className={item?.from_id === userData?.users?.id ? "UserList" : ""}>
                                  <div className="ChatInfoTop">
                                    <div className="ChatUserInfo">
                                      <h4 className={`${item?.types === "refer" ? "referTo" : ""}`}>
                                        {item?.to_id === userData?.users?.id ? (
                                          <>{item?.from}</>
                                        ) : item?.from_type === "Doctor" && item?.to_type === "Doctor" ? (
                                          `${item?.types === "refer" ? "You refer to Dr." : "to Dr."} ${item?.to}`
                                        ) : (
                                          "You"
                                        )}
                                        {/* {item?.to_id === userData?.users?.id ? (
                                          <>{item?.from}</>
                                        ) : "You" + item?.from_type === "Doctor" && item?.to_type === "Doctor" ? (
                                          `${item?.types === "refer" ? "refer to Dr." : "to Dr."} ${item?.to}`
                                        ) : item?.from_type === "Doctor" && item?.types === "refer" ? (
                                          `refer to Dr. ${item?.to_user_name}`
                                        ) : (
                                          ""
                                        )} */}
                                      </h4>
                                      <h5>{chatMessgaeDateFormat(item?.date)}</h5>
                                      {/* <h5>Today at 17:30</h5> */}
                                    </div>
                                  </div>
                                  {item?.message && item?.types !== "refer" ? (
                                    <div className={`DoctorChatContent ${item?.from_id !== userData?.users?.id ? "" : "DoctorChatContent2"}`}>
                                      {item?.message}
                                    </div>
                                  ) : null}

                                  {item?.file_name && item?.files ? (
                                    <div className={`DoctorChatContent ${item?.from_id !== userData?.users?.id ? "" : "DoctorChatContent2"} fileSection`}>
                                      {" "}
                                      {getFileExtension(item.file_name) === "pdf" ? (
                                        item?.from_id === userData?.users?.id ? (
                                          <img src={whitePdfIcon} className="downloadIcon normalIcon" alt="downloadIcon" />
                                        ) : (
                                          <img src={blackPdfIcon} className="downloadIcon normalIcon" alt="downloadIcon" />
                                        )
                                      ) : getFileExtension(item.file_name) === "docx" ? (
                                        item?.from_id === userData?.users?.id ? (
                                          <img src={whiteDocxIcon} className="downloadIcon normalIcon" alt="downloadIcon" />
                                        ) : (
                                          <img src={blackDocxIcon} className="downloadIcon normalIcon" alt="downloadIcon" />
                                        )
                                      ) : item?.from_id === userData?.users?.id ? (
                                        <img src={whiteImageIcon} className="downloadIcon normalIcon" alt="whiteImageIcon" />
                                      ) : (
                                        <img src={blackImageIcon} className="downloadIcon normalIcon" alt="whiteImageIcon" />
                                      )}
                                      {item?.file_name}{" "}
                                      {item?.from_id === userData?.users?.id ? (
                                        <img
                                          src={whiteDownloadIcon}
                                          className="downloadIcon"
                                          alt="downloadIcon"
                                          onClick={() => handleDownload(IMAGE_URL + item?.files, item?.file_name)}
                                        />
                                      ) : (
                                        <img
                                          src={downloadIcon}
                                          className="downloadIcon"
                                          alt="downloadIcon"
                                          onClick={() => handleDownload(IMAGE_URL + item?.files, item?.file_name)}
                                        />
                                      )}
                                    </div>
                                  ) : null}
                                </li>
                              ))
                            ) : (
                              <li className="EmptyChatSection">
                                <div className="DoctorChatContent">Conversation is empty.</div>
                              </li>
                            )
                          ) : null}

                          {/* <li className="UserList">
              <div className="ChatInfoTop">
                <div className="ChatUserInfo">
                  <h4>Kestrel Tabrizi</h4>
                  <h5>Today at 17:40</h5>
                </div>
              </div>
              <div className="DoctorChatContent DoctorChatContent2">
                Hi, I understand you're having some issues with your ankle. Can you tell me a little bit about what's going on?
                <br />
                <br />
                Let's conversation together to betterment your issues!
              </div>
            </li> */}
                        </ul>
                        <div className="BottomChatTextBox">
                          <textarea
                            className="FormTextarea"
                            placeholder="Write a message here..."
                            value={messageText}
                            onChange={e => setMessageText(e.target.value)}></textarea>
                          {messageSenderObj ? (
                            <div className="showSenderSection">
                              <span>
                                To {messageSenderObj?.type === "to-doctor" ? "doctor" : messageSenderObj?.type === "to-patient" ? "patient" : ""}:{" "}
                                <span className="nameSection">
                                  {messageSenderObj?.selectedItem?.first_name} {messageSenderObj?.selectedItem?.last_name}
                                </span>
                                <span>
                                  {" "}
                                  <img src={CrossIcon} className="CrossIcon" onClick={() => setMessageSenderObj(null)} />
                                </span>
                              </span>
                            </div>
                          ) : null}

                          <a className="ChatAttachIcon">
                            {!messageFile ? (
                              <>
                                <img src={ChatAttachIcon} alt="Doctor image" onClick={() => chatFileRef?.current?.click()} />
                                <input
                                  type="file"
                                  accept="image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  hidden
                                  ref={chatFileRef}
                                  onChange={e => handleChatFileChange(e)}
                                />
                              </>
                            ) : (
                              <div className="selectedFileSection">
                                <span>{messageFile?.name}</span>
                                <span>
                                  <img src={CrossIcon} className="CrossIcon" onClick={() => setMessageFile(null)} />
                                </span>
                              </div>
                            )}
                          </a>
                          <button className="ChatButton" disabled={messageSending} onClick={() => handleSendMesssage()}></button>
                        </div>
                      </div>
                    </>
                  )
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {/* ) : null} */}
      </div>
    </div>
  );
};

export default DoctorPatientMessage;
